import axios from 'axios';
import rebrand from '../../config/rebrand';

export default class Klickart {
  constructor() {
    this.axios = axios.create({ baseURL: rebrand.urls.KLICKART_URL });
  }

  get config() {
    return { withCredentials: true };
  }

  get(resource = '', config = {}) {
    return this.axios.get(resource, Object.assign({}, this.config, config));
  }

  put(resource = '', data, config = {}) {
    return this.axios.put(resource, data, Object.assign({}, this.config, config));
  }

  post(data, config = {}, resource = '') {
    return this.axios.post(resource, data, Object.assign({}, this.config, config));
  }

  delete(resource = '', config = {}) {
    return this.axios.delete(resource, Object.assign({}, this.config, config));
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/klickart.js
 **/